import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
import comments from './comments'
/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::index
* @see app/Http/Controllers/Teacher/TeacherContentController.php:22
* @route '/teacher/content'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/content',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::index
* @see app/Http/Controllers/Teacher/TeacherContentController.php:22
* @route '/teacher/content'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::index
* @see app/Http/Controllers/Teacher/TeacherContentController.php:22
* @route '/teacher/content'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::index
* @see app/Http/Controllers/Teacher/TeacherContentController.php:22
* @route '/teacher/content'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::create
* @see app/Http/Controllers/Teacher/TeacherContentController.php:87
* @route '/teacher/content/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/teacher/content/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::create
* @see app/Http/Controllers/Teacher/TeacherContentController.php:87
* @route '/teacher/content/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::create
* @see app/Http/Controllers/Teacher/TeacherContentController.php:87
* @route '/teacher/content/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::create
* @see app/Http/Controllers/Teacher/TeacherContentController.php:87
* @route '/teacher/content/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::store
* @see app/Http/Controllers/Teacher/TeacherContentController.php:98
* @route '/teacher/content'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/teacher/content',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::store
* @see app/Http/Controllers/Teacher/TeacherContentController.php:98
* @route '/teacher/content'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::store
* @see app/Http/Controllers/Teacher/TeacherContentController.php:98
* @route '/teacher/content'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::show
* @see app/Http/Controllers/Teacher/TeacherContentController.php:106
* @route '/teacher/content/{content}'
*/
export const show = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/teacher/content/{content}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::show
* @see app/Http/Controllers/Teacher/TeacherContentController.php:106
* @route '/teacher/content/{content}'
*/
show.url = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { content: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: typeof args.content === 'object'
        ? args.content.id
        : args.content,
    }

    return show.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::show
* @see app/Http/Controllers/Teacher/TeacherContentController.php:106
* @route '/teacher/content/{content}'
*/
show.get = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::show
* @see app/Http/Controllers/Teacher/TeacherContentController.php:106
* @route '/teacher/content/{content}'
*/
show.head = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::edit
* @see app/Http/Controllers/Teacher/TeacherContentController.php:163
* @route '/teacher/content/{content}/edit'
*/
export const edit = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/teacher/content/{content}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::edit
* @see app/Http/Controllers/Teacher/TeacherContentController.php:163
* @route '/teacher/content/{content}/edit'
*/
edit.url = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { content: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: typeof args.content === 'object'
        ? args.content.id
        : args.content,
    }

    return edit.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::edit
* @see app/Http/Controllers/Teacher/TeacherContentController.php:163
* @route '/teacher/content/{content}/edit'
*/
edit.get = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::edit
* @see app/Http/Controllers/Teacher/TeacherContentController.php:163
* @route '/teacher/content/{content}/edit'
*/
edit.head = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::update
* @see app/Http/Controllers/Teacher/TeacherContentController.php:216
* @route '/teacher/content/{content}'
*/
export const update = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/content/{content}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::update
* @see app/Http/Controllers/Teacher/TeacherContentController.php:216
* @route '/teacher/content/{content}'
*/
update.url = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { content: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: typeof args.content === 'object'
        ? args.content.id
        : args.content,
    }

    return update.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::update
* @see app/Http/Controllers/Teacher/TeacherContentController.php:216
* @route '/teacher/content/{content}'
*/
update.put = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::destroy
* @see app/Http/Controllers/Teacher/TeacherContentController.php:330
* @route '/teacher/content/{content}'
*/
export const destroy = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/teacher/content/{content}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::destroy
* @see app/Http/Controllers/Teacher/TeacherContentController.php:330
* @route '/teacher/content/{content}'
*/
destroy.url = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { content: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: typeof args.content === 'object'
        ? args.content.id
        : args.content,
    }

    return destroy.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::destroy
* @see app/Http/Controllers/Teacher/TeacherContentController.php:330
* @route '/teacher/content/{content}'
*/
destroy.delete = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::muxUploadUrl
* @see app/Http/Controllers/Teacher/TeacherContentController.php:228
* @route '/teacher/content/mux-upload-url'
*/
export const muxUploadUrl = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadUrl.url(options),
    method: 'post',
})

muxUploadUrl.definition = {
    methods: ["post"],
    url: '/teacher/content/mux-upload-url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::muxUploadUrl
* @see app/Http/Controllers/Teacher/TeacherContentController.php:228
* @route '/teacher/content/mux-upload-url'
*/
muxUploadUrl.url = (options?: RouteQueryOptions) => {
    return muxUploadUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::muxUploadUrl
* @see app/Http/Controllers/Teacher/TeacherContentController.php:228
* @route '/teacher/content/mux-upload-url'
*/
muxUploadUrl.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadUrl.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::muxUploadStatus
* @see app/Http/Controllers/Teacher/TeacherContentController.php:255
* @route '/teacher/content/mux-upload-status'
*/
export const muxUploadStatus = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadStatus.url(options),
    method: 'post',
})

muxUploadStatus.definition = {
    methods: ["post"],
    url: '/teacher/content/mux-upload-status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::muxUploadStatus
* @see app/Http/Controllers/Teacher/TeacherContentController.php:255
* @route '/teacher/content/mux-upload-status'
*/
muxUploadStatus.url = (options?: RouteQueryOptions) => {
    return muxUploadStatus.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::muxUploadStatus
* @see app/Http/Controllers/Teacher/TeacherContentController.php:255
* @route '/teacher/content/mux-upload-status'
*/
muxUploadStatus.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadStatus.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::toggleFree
* @see app/Http/Controllers/Teacher/TeacherContentController.php:341
* @route '/teacher/content/{content}/toggle-free'
*/
export const toggleFree = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleFree.url(args, options),
    method: 'post',
})

toggleFree.definition = {
    methods: ["post"],
    url: '/teacher/content/{content}/toggle-free',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::toggleFree
* @see app/Http/Controllers/Teacher/TeacherContentController.php:341
* @route '/teacher/content/{content}/toggle-free'
*/
toggleFree.url = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { content: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: typeof args.content === 'object'
        ? args.content.id
        : args.content,
    }

    return toggleFree.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentController::toggleFree
* @see app/Http/Controllers/Teacher/TeacherContentController.php:341
* @route '/teacher/content/{content}/toggle-free'
*/
toggleFree.post = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleFree.url(args, options),
    method: 'post',
})

const content = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    muxUploadUrl: Object.assign(muxUploadUrl, muxUploadUrl),
    muxUploadStatus: Object.assign(muxUploadStatus, muxUploadStatus),
    toggleFree: Object.assign(toggleFree, toggleFree),
    comments: Object.assign(comments, comments),
}

export default content